<template>
  <v-card-text >
    <v-layout row wrap>
      <v-flex xs12 sm4="sm4">
        <v-text-field v-model="search" outlined dense append-icon="mdi-magnify" label="Search" single-line="single-line"
          hide-details clearable="clearable">
        </v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex v-if="Repairs" shrink class="text-h4">
        {{ Repairs.length }}
      </v-flex>
    </v-layout>
    <v-data-table class="mt-4" :loading="loading" :search="search" :headers="headers" :items="Repairs" :sort-by="sortBy"
      :page.sync="page" :items-per-page="itemsPerPage">
      <template v-slot:item="{ item }">
        <tr class="pointer">
          <td class="text-left small-td pointer">
            <div>{{ item.RepairDetailID }}</div>
          </td>

          <td class="text-left small-td pointer">{{ item.RepairDate | moment("LL LT") }}</td>
          <td class="text-left small-td pointer">{{ item.CustomerName }} </td>
          <td class="text-left small-td pointer">{{ item.CustomerPhoneNumber }}</td>
          <td class="text-left small-td pointer">
            <div>{{ item.ProductName }}</div>
            <div class="text-capitalize text--disabled font-italic">-{{ item.EmployeeName }}</div>
            <!-- <div class="text-capitalize text--disabled font-italic">-{{ item.IMEINumber }}</div>  -->
          </td>
          <td class="text-left small-td pointer">
            <div>{{ item.IMEINumber }}</div>
          </td>

          <td class="text-right small-td pointer">{{ item.DueAmount | currency }}</td>
          <td class="text-right small-td pointer">{{ item.RepairPrice | currency }}</td>
        </tr>
      </template>

    </v-data-table>
  </v-card-text>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DateTimePicker from '@/components/DateTimePicker.vue'
import reportService from '@/pages/Report/service.js'

export default {
  name: 'repair-list',
  props: ['location'],
  data() {
    return {
      search: '',
      loading: false,
      Repairs: [],
      sortBy: "RepairDetailID",
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      headers: [
        {
          text: 'ID',
          align: "left",
          sortable: true,
          value: "RepairDetailID"
        },
        {
          text: 'Date',
          align: "left",
          sortable: true,
          value: "RepairDate"
        },
        {
          text: 'Customer',
          align: "left",
          sortable: true,
          value: "CustomerName"
        },
        {
          text: 'Phone Number',
          align: "left",
          sortable: true,
          value: "CustomerPhoneNumber"
        },
        {
          text: 'Item Name',
          align: "left",
          sortable: true,
          value: "ProductName"
        },
        {
          text: 'IMEI Number',
          align: "left",
          sortable: true,
          value: "IMEINumber"
        },
        {
          text: 'DueAmount',
          align: 'right',
          value: "DueAmount",
          sortable: true
        },
        {
          text: 'Repair Price',
          align: 'right',
          value: "RepairPrice",
          sortable: true
        },

      ],
    }
  },
  watch: {
    location(val) {
      this.getRepairList(val)
    }
  },
  computed: {
    ...mapGetters('report', ['batchList', 'selectedLocation'])
  },
  components: {
    DateTimePicker,
  },
  created() {
    this.getRepairList()
    // if (this.$route.params.location) {
    //   this.location = this.$route.params.location
    //   this.getRepairList()
    // } else {
    //   if (this.selectedLocation) {
    //     this.location = this.selectedLocation
    //   }
    // }
  },
  methods: {
    ...mapActions('report', ['setSelectedLocation']),

    getRepairList() {
      if (!this.location) return false
      this.Repairs = []
      this.loading = true
      return reportService
        .getRepairList(this.location.storeID)
        .then(response => {
          // console.log("getInvoiceList", response);
          this.loading = false
          this.Repairs = response.data
          // this.setBatchList(this.Batches)
          return response;
        }).catch(error => {
          this.loading = false
        })

    }
  }
}
</script>

<style scoped>
</style>